import { FunctionComponent, useEffect, useState } from "react";
import { getActiveSite } from "../../selectors/sites.js";
import { injectScript } from "../../slices/loadStates.js";
import { useAppDispatch, useAppSelector } from "../../store/hooks.js";
import styles from "../../stylesheets/components/brandnamic-voucher-app-module.module.css";
import moduleBaseStyles from "../../stylesheets/components/module-base.module.css";
import {
  BaseModuleProps,
  VoucherAppModuleSettings,
} from "../../types/index.js";
import {
  getActiveColorScheme,
  getSupportedLanguage,
} from "../../utils/utils.js";
import LazyloadWrapper from "../LazyloadWrapper.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";

type Props = BaseModuleProps<VoucherAppModuleSettings>;

const VoucherAppModule: FunctionComponent<Props> = ({
  translatedModule: {
    id,
    settings: { textAlign, code },
    translation: {
      languageId,
      settings: { title, subtitle },
    },
  },
  translatedModule,
  isFirstOnPage,
  isPreview,
}) => {
  const dispatch = useAppDispatch();

  const scheme = useAppSelector((state) =>
    getActiveColorScheme(
      state.colorSchemes,
      getActiveSite(state.sites),
      translatedModule,
    ),
  );
  const [isLazyloaded, setIsLazyloaded] = useState(false);

  useEffect(() => {
    code &&
      isLazyloaded &&
      dispatch(
        injectScript("https://cdn.bnamic.com/voucher-app/voucher-app.js"),
      );
  }, [isLazyloaded, isPreview, code]);

  return (
    <ModuleWithHeadings
      title={title}
      subtitle={subtitle}
      id={id}
      className={styles.VoucherAppModule}
      colors={{ background: scheme.main.separator, color: scheme.main.text }}
    >
      <div className={moduleBaseStyles.Module__Wrapper}>
        <ModuleHeadings
          scheme={scheme}
          isFirstOnPage={isFirstOnPage}
          textAlign={textAlign}
          title={title}
          subtitle={subtitle}
        />
      </div>

      <LazyloadWrapper onLoad={setIsLazyloaded}>
        <div className={moduleBaseStyles.Module__Wrapper}>
          {!!code ? (
            <bn-voucher-app
              id="BN-voucher-app"
              class="BN-voucher-app"
              data-lang={getSupportedLanguage(languageId, ["de", "it", "en"])}
              data-code={code}
            />
          ) : (
            <div className={styles.VoucherAppModule__Empty}>VoucherApp</div>
          )}
        </div>
      </LazyloadWrapper>
    </ModuleWithHeadings>
  );
};

export default VoucherAppModule;
